<template>
  <div>
    <h5>Simulação</h5>

    <div class="row" v-show="!novaSimulacao && desembolso!=undefined">
      <div class="col s12">
        <div class="card">
          <table class=" bordered">
            <tbody>
            <tr>
              <th>Produto</th>
              <td>{{form.produto_nome}}</td>
              <th>Data desembolso</th>
              <td>{{form.data_desembolso}}</td>
            </tr>
            <tr>
              <th>Numero de parcelas</th>
              <td>{{form.numero_parcelas}}</td>
              <th>Dia pagamento</th>
              <td>{{form.dia_pagamento}}</td>
            </tr>
            <tr>
              <th>Total</th>
              <td>{{form.total | currency('R$', 2, ',', '.')}}</td>
              <td colspan="2">
                <button v-bind:disabled="fazendo_simulacao"
                        class="waves-effect waves-light btn btn-default"
                        @click="fazerNovaSimulacao()" v-if="!$hasRole('is_guest')">Alterar simulação
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="div"  v-show="novaSimulacao || desembolso==undefined" >
       <label >(*)Campos obrigatórios.</label>
    </div>
    <div class="row" v-show="novaSimulacao || desembolso==undefined">
      <template v-show="!is_promotor">
        <div class="input-field col s6" v-if="produtos_kredits.length > 0">
          <material-select id="produto_kredits" v-model="produto">
            <option disabled selected hidden value=""></option>
            <option v-for="produto_kredits in produtos_kredits" :key="produto_kredits.loan_id"
              :disabled ="is_promotor"
              :value="JSON.stringify(produto_kredits)">
              {{ exibirOption(produto_kredits) }}
            </option>
          </material-select>
          <label v-if="!is_promotor" for="produto_kredits">
            Produto*
          </label>
          <label v-else for="produto_kredits">
            AUTOMATICO
          </label>
        </div>
        <div class="col s6" v-else>
          Carregando produtos...
        </div>
      </template>

      <div class="col" :class="{ s4: is_promotor, s6: !is_promotor }">
        <mask-money id="total"
                    v-model="form.total"
                    label="Total*"></mask-money>
      </div>

      <div class="input-field col s4" v-show="!is_promotor">
        <input :disabled="is_promotor == true" type="tel" class="input mask-date" id="data_desembolso"
               v-model.lazy="form.data_desembolso">
        <label for="data_desembolso">Data de desembolso*</label>
      </div>

      <div class="input-field col s4" v-show="!is_promotor">
        <input :disabled="is_promotor == true" type="number" class="input" id="dia_pagamento"
               v-model="form.dia_pagamento">
        <label for="dia_pagamento">Dia do pagamento*</label>
      </div>

      <div class="input-field col s4">
        <input type="number" class="input" id="numero_parcelas" v-model="form.numero_parcelas">
        <label for="numero_parcelas">Número de parcelas*</label>
      </div>

      <div v-show="is_promotor" class="input-field col s4">
        <label for="royal_garantee">
                <input
                  class="filled-in"
                  type="checkbox"
                  v-model="form.royal_garantee"
                  id="royal_garantee"
                />
                <span>Tabela com Garantia Real</span>
        </label>
      </div>

      <div class="col s12">
        <button class="waves-effect waves-light btn" @click="alteraDesembolso" v-if="desembolso">Gerar simulação
        </button>
        <button class="waves-effect waves-light btn" @click="gerarSimulacao" v-else>Gerar simulação</button>
      </div>
    </div>

    <div class="row" v-if="fazendo_simulacao">
      <div class="col s12 center">
        <div class="preloader-wrapper small active">
          <div class="spinner-layer spinner-blue">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div>
            <div class="gap-patch">
              <div class="circle"></div>
            </div>
            <div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>

          <div class="spinner-layer spinner-red">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div>
            <div class="gap-patch">
              <div class="circle"></div>
            </div>
            <div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>

          <div class="spinner-layer spinner-yellow">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div>
            <div class="gap-patch">
              <div class="circle"></div>
            </div>
            <div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>

          <div class="spinner-layer spinner-green">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div>
            <div class="gap-patch">
              <div class="circle"></div>
            </div>
            <div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <simulacao-parcelas-resultado :roles="this.roles" :resultado_simulacao="resultado_simulacao"
                                  :data_desembolso="form.data_desembolso"
                                  :loading="fazendo_simulacao"></simulacao-parcelas-resultado>


    <div v-if="limiteValorProduto" class="row">
      <div class="card-panel orange lighten-2 white-text col s12 center ">
        <p><i class="material-icons left">warning</i>Valor não está em conformidade com o Produto selecionado</p>
      </div>
    </div>
  </div>
</template>

<script>
  import SimulacaoParcelasResultado from './SimulacaoParcelasResultado'

  export default {
    components: {
      'SimulacaoParcelasResultado': SimulacaoParcelasResultado
    },
    props: [
      'desembolso'
    ],
    data: function() {
      return {
        fazendo_simulacao: false,
        novaSimulacao: false,
        produto: '',
        form: {
          loan_ID: '',
          total: '',
          data_desembolso: '',
          dia_pagamento: '',
          numero_parcelas: '',
          produto_nome: '',
          royal_garantee: ''
        },
        resultado_simulacao: {
          parcelas: [],
          total: '',
          total_emprestimo: '',
          total_liquido: '',
          total_juros: '',
          total_taxas: '',
          juros_mensal: ''
        },
        produtos_kredits: []
      }
    },
    watch : {
      form: {
        handler: function(newValue) {
          this.parcelas = [];
        },
        deep: true
      },
      limiteValorProduto: function (newVal) {
        this.$emit('limite', newVal);
      },
      produto(value) {
        if (value == undefined) return;

        let obj = JSON.parse(value);
        this.form.loan_ID = obj.LoanID;
        this.form.produto_nome = obj.TplName;
        this.resultado_simulacao.juros_mensal = obj.IntRate;
        this.resultado_simulacao.valor_minimo = obj.LnAmtMin;
        this.resultado_simulacao.valor_maximo = obj.LnAmtMax;
      },
      novaSimulacao: function (newVal) {
        this.$emit('nova-simulacao', newVal);
      },
    },
    updated() {
      if(typeof Materialize.updateTextFields != 'undefined')
        Materialize.updateTextFields();
    },
    mounted() {
      this.obterProdutosKredits();

      if (this.is_promotor) {
        this.form.data_desembolso = moment().format('DD/MM/Y');
        this.form.dia_pagamento = moment().format('DD');
      }

      if (this.desembolso != undefined) {
        this.form = this.desembolso;
        this.gerarSimulacao();
      }
    },
    methods: {
      alteraDesembolso: function () {
        let that = this;
        that.fazendo_simulacao = true;

        return axios.post('/ajax/alterar-desembolso/' + this.form.formulario_id, {
          simulacao: that.form,
        }).then(function (response) {
          that.fazendo_simulacao = false;
          that.novaSimulacao = false;
          that.gerarSimulacao();
        })
        .catch(error => {
           if (typeof response != 'undefined' && response.status == 422) {
                    Materialize.toast({html:'error-modal ' + response.data.errors});
          } else {
          switch(error.status){
            case 400:
              that.fazendo_simulacao = false;
                Materialize.toast({html:'Problemas na requisição, entre em contato com o suporte'});
              break;
            case 401:
              that.fazendo_simulacao = false;
                Materialize.toast({html:'Requisição não autorizada, entre em contato com o suporte'});
              break;
            case 403:
              that.fazendo_simulacao = false;
             Materialize.toast({html:'Acesso ao recurso não autorizado, entre em contato com o suporte'});
              break;
            case 404:
              that.fazendo_simulacao = false;
              Materialize.toast({html:'Recurso não foi encontrado, entre em contato com o suporte'});
              break;
            case 429:
              that.fazendo_simulacao = false;
               Materialize.toast({html:'Limite de requisição atingido, entre em contato com o suporte'});
              break;
            case 500:
              that.fazendo_simulacao = false;
             Materialize.toast({html:'Serviço fora do ar, entre em contato com o suporte.'});
              break;
            case 503:
              that.fazendo_simulacao = false;
              Materialize.toast({html:'Serviço indisponivel, tente novamente mais tarde.'});
              break;
            case 504:
              that.fazendo_simulacao = false;
             Materialize.toast({html:'Existem problemas na rede, entre em contato com suporte.'});
              break;
            default:
              that.fazendo_simulacao = false;
               Materialize.toast({html: 'Aconteceu algo inesperado! Entre em contato com o suporte'});
          }
          }
        });
                // .catch(({response}) => {
                //   that.fazendo_simulacao = false;

                //   if (typeof response != 'undefined' && response.status == 422) {
                //     bus.$emit('error-modal', response.data.errors);
                //   } else {
                //     bus.$emit('error-modal', {erros: ['Erro! Verifique sua conexão!']});
                //   }
                // });
      },
      fazerNovaSimulacao: function () {
        this.novaSimulacao = true;
        this.resultado_simulacao = {
          parcelas: []
        }
      },
      gerarSimulacao() {
        let that = this;

        that.fazendo_simulacao = true;

        axios.get('/ajax/simulacao-parcelas-kredits', {
          params: that.form
        }).then(function (response) {
          that.resultado_simulacao.parcelas = response.data.parcelas;
          that.resultado_simulacao.total = response.data.total;
          that.resultado_simulacao.total_emprestimo =response.data.total_emprestimo;
          that.resultado_simulacao.total_liquido = response.data.total_liquido;
          that.resultado_simulacao.total_juros = response.data.total_juros;
          that.resultado_simulacao.total_taxas = response.data.total_taxas;

          // Se for promotor, vamos setar qual foi o produto
          if (that.is_promotor) {
            let produto_kredits = that.produtos_kredits.find(x => x.LoanID === response.data.produto);
            that.produto = JSON.stringify(produto_kredits);
          }

          that.fazendo_simulacao = false;

          that.$emit('simulou-parcela');
        }).catch(error => {
           if (typeof response != 'undefined' && response.status == 422) {
             that.fazendo_simulacao = false;
               Materialize.toast({html: 'error-modal '+ response.data.errors});
          } else {
                    // bus.$emit('error-modal', {erros: ['Erro! Verifique sua conexão!']});
          switch(error.status){
            case 400:
              that.fazendo_simulacao = false;
              Materialize.toast({html: 'Problemas na requisição, entre em contato com o suporte'});
              break;
            case 401:
              that.fazendo_simulacao = false;
              Materialize.toast({html: 'Requisição não autorizada, entre em contato com o suporte'});
              break;
            case 403:
              that.fazendo_simulacao = false;
              Materialize.toast({html: 'Acesso ao recurso não autorizado, entre em contato com o suporte'});
              break;
            case 404:
              that.fazendo_simulacao = false;
              Materialize.toast({html: 'Recurso não foi encontrado, entre em contato com o suporte'});
              break;
            case 429:
              that.fazendo_simulacao = false;
              Materialize.toast({html: 'Limite de requisição atingido, entre em contato com o suporte'});
              break;
            case 500:
              that.fazendo_simulacao = false;
            Materialize.toast({html: 'Serviço fora do ar, entre em contato com o suporte.'});
              break;
            case 503:
              that.fazendo_simulacao = false;
             Materialize.toast({html: 'Serviço indisponivel, tente novamente mais tarde.'});
              break;
            case 504:
              that.fazendo_simulacao = false;
             Materialize.toast({html: 'Existem problemas na rede, entre em contato com suporte.'});
              break;
            default:
              that.fazendo_simulacao = false;
              Materialize.toast({html:  'Aconteceu algo inesperado! Entre em contato com o suporte'});
          }
              }
        });
               /* .catch(({response}) => {
                  that.fazendo_simulacao = false;

                  if (typeof response != 'undefined' && response.status == 422) {
                    bus.$emit('error-modal', response.data.errors);
                  } else {
                    bus.$emit('error-modal', {erros: ['Erro! Verifique sua conexão!']});
                  }
                });*/
      },
      obterProdutosKredits: function () {
        let that = this;
        axios.get('/ajax/produtos-kredits-adapter')
                .then(function (response) {
                  that.produtos_kredits = response.data;

                  let produto_kredits = that.produtos_kredits.find(x => x.LoanID === that.form.loan_ID);
                  that.produto = JSON.stringify(produto_kredits);

                  setTimeout(function () {
                    bus.$emit('updateFormCliente');
                  }, 100);
                }).catch(error => {
                     that.fazendo_simulacao = false;
                  Materialize.toast({html: 'Não foi possivel carregar os produtos: '+error});
                  });
  
      },
      dataFormatada(data) {
        return moment(data).format('DD/MM/Y');
      },
      exibirOption(produto_kredits) {
        if(this.is_promotor){
          return (produto_kredits.IntRate * 100).toFixed(2) + '%'
        }
        return produto_kredits.TplName + ' (' + (produto_kredits.IntRate * 100).toFixed(2) + '%)';
      },
    },
    computed: {
      is_promotor() {
        return this.$hasRole('promotor');
      },
      limiteValorProduto: function () {
        if (this.resultado_simulacao.total_liquido) {
          return this.resultado_simulacao.total_liquido < this.resultado_simulacao.valor_minimo ||
                  this.resultado_simulacao.total_liquido > this.resultado_simulacao.valor_maximo
        }
        return false;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/SimulacaoParcelas.vue